export var EvergreenCommunityListingSignupRequestSource;
(function (EvergreenCommunityListingSignupRequestSource) {
    EvergreenCommunityListingSignupRequestSource["AvailabilityRequestEmail"] = "AvailabilityRequestEmail";
    EvergreenCommunityListingSignupRequestSource["ClientIntakeEmail"] = "ClientIntakeEmail";
    EvergreenCommunityListingSignupRequestSource["OutreachCampaign"] = "OutreachCampaign";
})(EvergreenCommunityListingSignupRequestSource || (EvergreenCommunityListingSignupRequestSource = {}));
//# sourceMappingURL=types.js.map